import React from 'react';
import { useHistory } from 'react-router-dom';

const SECTIONS = [
  {
    title: '數位憑證：建構全國大專校院學位憑證之可信流通與應用基礎',
    desc: '以全國大專校院學位證明為核心，推動數位學位憑證之發行、驗證與應用，並銜接數位憑證皮夾及國際數位憑證發展趨勢。透過一致且可信的數位憑證機制，逐步拓展升學、求職、資格審查及跨境驗證等應用場景，促進學位證明於不同平台與場域間安全流通。',
  },
  {
    title: '數位證書：整合多元發證單位，建立可信賴的數位證書服務體系',
    desc: '服務範圍涵蓋全國大專校院學位證書、專科以上學校及高中以下教師證書，並延伸至語言能力、學程學分、專業資格等多元證明。透過與大專校院、教育相關機關及專業發證機構合作，持續擴充數位證書應用範疇，建立從發行、驗證至後續應用的可信數位證明環境。',
  },
  {
    title: '批次驗證：從單筆查驗延伸至大規模驗證，提升跨機構證明查驗效率',
    desc: '針對招生、任用、資格審查等大量證書查驗需求，將既有電子證書驗證機制延伸至批次驗證服務。凡可於教育部電子證書驗證系統進行驗證之電子證書，皆可透過本中心進行大量集中查驗，協助學校、政府機關及各類機構更有效率地完成證明真偽確認與資格審查。',
  },
];

export const ArchitecturePage: React.FC = () => {
  const history = useHistory();

  return (
    <>
      <h1>服務架構</h1>
      <p className="dc-lead">以可信、互通與可驗證為核心，建構數位憑證、數位證書與批次驗證三大服務體系。</p>

      <div className="dc-document">
        {SECTIONS.map((sec, idx) => (
          <section key={idx} className="dc-doc-section">
            <h2>{sec.title}</h2>
            <p>{sec.desc}</p>
          </section>
        ))}
      </div>

      <div className="dc-actions">
        <button
          type="button"
          className="dc-button"
          onClick={() => history.push('/about')}
        >
          回到中心介紹
        </button>
        <button
          type="button"
          className="dc-button"
          onClick={() => history.push('/about/partners')}
        >
          查看合作單位
        </button>
        <button
          type="button"
          className="dc-button"
          onClick={() => history.push('/about/faq')}
        >
          查看常見問題
        </button>
      </div>
    </>
  );
};

export default ArchitecturePage;
